import React, { forwardRef } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const KioskBackgroundDefault = forwardRef<SVGSVGElement, SvgIconProps>(
  function KioskBackgroundDefault(props, ref) {
    return (
      <SvgIcon
        height="428px"
        ref={ref}
        viewBox="0 0 1024 428"
        width="1024px"
        {...props}
      >
        <defs>
          <linearGradient
            id="a"
            x1="50%"
            x2="48.718338%"
            y1="47.829784%"
            y2="54.277162%"
          >
            <stop offset="0%" stopColor="#FFFCF9" />
            <stop offset="100%" stopColor="#F6F0EB" />
          </linearGradient>
        </defs>
        <path
          d="M1205 304v464c-292.383202-122.33301-463.000461-99.114151-730.188794-55.566252C219.209872 754.09313-22.3305153 724.064309-151 653.275632V304h1356z"
          fill="url(#a)"
          fillRule="evenodd"
          transform="rotate(180 527 366)"
        />
      </SvgIcon>
    )
  },
)

export default KioskBackgroundDefault
